// extracted by mini-css-extract-plugin
module.exports = {"card":"ProfileCollectionCard_card__s2gVP","tag":"ProfileCollectionCard_tag___nUKx"};